<template>
  <v-form ref="form" @submit.prevent="save">
    <v-card>
      <v-card-title>{{ $t('assignGroups') }}</v-card-title>
      <v-card-text>
        <v-container class="pa-0">
          <v-autocomplete
            v-model="assignedGroups"
            :items="groups"
            :loading="loading"
            item-text="cn"
            item-value="dn"
            chips
            deletable-chips
            multiple
            autofocus
          ></v-autocomplete>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="accent" depressed @click="close">{{ $t('cancel') }}</v-btn>
        <v-btn type="submit" color="primary" depressed>{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import api from '@/api'

export default {
  props: {
    uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      assignedGroups: [],
      groups: [],
      errorMessages: {},
    }
  },
  watch: {
    uuid: {
      handler() {
        this.fetchUser()
        this.fetchGroups()
      },
      immediate: true,
    },
  },
  methods: {
    async fetchUser() {
      this.loading = true
      const resp = await api.get(`/api/users/${this.uuid}`)
      this.assignedGroups = resp.data.groups
      this.loading = false
    },
    async fetchGroups() {
      this.loading = true
      const resp = await api.get('/api/groups/?page_size=1000')
      this.groups = resp.data.results
      this.loading = false
    },
    close() {
      this.errorMessages = {}
      this.$refs.form.reset()
      this.$emit('close-dialog')
    },
    async save() {
      const data = {
        groups: this.assignedGroups,
      }
      this.loading = true
      try {
        const resp = await api.patch(`/api/users/${this.uuid}`, data)
        this.groups = resp.data.groups
        this.$emit('close-dialog')
        this.$emit('reload-users')
      } catch (error) {
        if (error.response && error.response.status === 400) {
          this.errorMessages = error.response.data
        }
      }
      this.loading = false
    },
  },
}
</script>
